import React from 'react';
import { useNavigate } from 'react-router';
import { AppRoutes } from 'routes/app-routes';

export const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleRouteToTermsOfService = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate(AppRoutes.TermsOfService);
  };

  return (
    <div className="flex w-full justify-center items-center gap-2.5 px-0 py-8">
      <p className="text-sky text-center text-xs font-medium leading-[17px]">
        By using the application you acknowledge you have read and agree to our&nbsp;
        <a href={AppRoutes.TermsOfService} onClick={handleRouteToTermsOfService} className="text-indigo underline">
          Terms of Services
        </a>
      </p>
    </div>
  );
};
